/* eslint-disable complexity, sonarjs/cognitive-complexity, max-len */
import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import type { StyledSimpleSkeletonLoaderProps } from './SimpleSkeletonLoader.style.types'

import getLoaderSize from './helpers/getLoaderSize'

export const SimpleSkeletonLoader = styled.div((props: StyledSimpleSkeletonLoaderProps): FlattenSimpleInterpolation => {
  const { backgroundColor, accentColor, inverse } = props.simpleSkeletonLoaderTheme.appearance[props.appearance!]

  return css`
    width: 100%;

    ${getLoaderSize('width', props.width)};
    ${getLoaderSize('height', props.height)};

    background-color: ${props.inverse ? inverse.backgroundColor : backgroundColor};
    position: relative;
    overflow: hidden;
    border-radius: ${props.type === 'rect' ? props.theme.border.radius[2] : '50%'};

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background: ${props.inverse ? inverse.accentColor : accentColor};
      animation: skeleton-loading 1s infinite;
      content: '';
    }

    @keyframes skeleton-loading {
      100% {
        transform: translateX(100%);
      }
    }
  `
})
